import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { AnimalProposalModel } from "../../../../helpers/catAndDogProposal";
import Header from "../../../sharedComponents/header/header";
import Race from "./race";
import Age from "./age";
import AnimalName from "./animalName";

interface AnimalProps {
    calculateStore?: CalculateStore;
    animal: AnimalProposalModel;
    headerText: string;
}

export function Animal(props: AnimalProps) {
    return (
        <div className="section cat-and-dog">
            <Header type="medium" mainHeader={props.headerText} />
            <AnimalName name={props.animal.name} />
            <Race race={props.animal.race} />
            <Age age={props.animal.age} />
        </div>
    );
}

export default inject("calculateStore")(observer(Animal));
